module.exports = __webpack_public_path__ + "img/9788901069500.aa656160.jpg";